import { Input } from "@mantine/core";
import { t } from "i18next";

import { colors } from "#app/theme/v1/colors";
import { Icon } from "#shared/icons/Icon";
import { Group } from "#shared/view/components/Group";
import { Text } from "#shared/view/components/Text";
import { SelectInputController } from "#shared/view/designSystem/inputs/SelectInputController";
import { RichTooltip } from "#shared/view/designSystem/RichTooltip";
import {
  FormatterMaterialParameter,
  MaterialGradeType,
  MaterialLayout,
  PartTypeType,
} from "shared";

import { MATERIAL_DIMENSIONS_INPUT_WIDTH } from "../../PredictionData/constants";
import { useMaterialDimensionsSelect } from "./useMaterialDimensionsSelect";

export const MaterialDimensions = ({
  materialLayout,
  materialGrade,
  materialName,
  quoteRequestLineId,
  partType,
  partSubType,
  partDimensionsWithOverthickness,
}: {
  openMaterialLayoutModal: () => void;
  materialLayout: MaterialLayout;
  materialGrade: MaterialGradeType;
  materialName: string;
  quoteRequestLineId: string | undefined;
  partType: PartTypeType | null;
  partSubType: string | null;
  partDimensionsWithOverthickness: FormatterMaterialParameter;
}) => {
  const {
    selectId,
    dimensionExplanation,
    dimensionGroups,
    expandableSelectProps,
    value,
    onChange,
  } = useMaterialDimensionsSelect({
    materialLayout,
    materialGrade,
    materialName,
    quoteRequestLineId,
    partType,
    partSubType,
    partDimensionsWithOverthickness,
  });

  return (
    <Input.Wrapper style={{ minWidth: MATERIAL_DIMENSIONS_INPUT_WIDTH }}>
      <Input.Label htmlFor={selectId} style={{ display: "flex", gap: 4, alignItems: "center" }}>
        {t("qrl.dimensions.label")}
        <RichTooltip target={<Icon name="infoCircle" size={14} color={colors.violet[5]} />}>
          <Group gap={4} mb={4} align="center">
            <Icon name="infoCircle" size={14} />
            <Text fw="bold">{t("qrl.dimensions.materialDimensions")}</Text>
          </Group>
          {(Object.keys(dimensionExplanation) as (keyof typeof dimensionExplanation)[]).map(
            (key) =>
              dimensionExplanation[key] !== null ? (
                <Text key={key}>
                  {`${t(`qrl.dimensions.${key}`)} : ${dimensionExplanation[key] ?? "-"}mm`}
                </Text>
              ) : null,
          )}
        </RichTooltip>
      </Input.Label>

      <SelectInputController
        id={selectId}
        name="layout.materialLayout.materialId"
        placeholder={t("qrl.dimensions.select")}
        onChange={onChange}
        data={dimensionGroups}
        value={value}
        withEmptyData={false}
        allowDeselect={false}
        searchable
        disabled={dimensionGroups.length === 0}
        {...expandableSelectProps}
      />
    </Input.Wrapper>
  );
};
